import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../../helper/url_helper";
import { post, get, put } from "../../../helper/api_helper";
import { energySlice } from "./slice";
import { authSlice } from "../auth/slice";
import { showToast } from "../../../helper/common";
import { getValuesSocketData } from "../../../helper/secretManager";

export const getEnergyPackages = createAsyncThunk(
  "getEnergyPackages",
  async ({ data, callBack }, Thunk) => {
    try {
      if (data?.page === 1) {
        Thunk.dispatch(energySlice.actions.clearEnergyPackageList());
      }
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.ENERGY_PACKAGES_LIST, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      response.filter = data;
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getPurchaseLink = createAsyncThunk(
  "getPurchaseLink",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.GET_PURCHASE_LINK, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      // showToast(response?.message, "success");
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const checkPaymentStatus = createAsyncThunk(
  "checkPaymentStatus",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await get(
        URL.CHECK_PAYMENT_STATUS + `?purchaseID=${data?.purchaseID}`,
        { signature, nonce },
      );
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        // showToast(response?.message, "error");
        callBack && callBack(null, response);
        return response;
      }
      // showToast(response?.message, "success");
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const cancelPayment = createAsyncThunk(
  "cancelPayment",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await put(URL.CANCEL_PAYMENT + data?.purchaseID, null, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      // showToast(response?.message, "success");
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getHotOfferPackage = createAsyncThunk(
  "getHotOfferPackage",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await get(URL.GET_HOT_OFFER, { signature, nonce });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getPackagePurchaseHistory = createAsyncThunk(
  "getPackagePurchaseHistory",
  async ({ data, callBack }, Thunk) => {
    try {
      if (data?.page === 1) {
        Thunk.dispatch(energySlice.actions.clearPackagePurchaseHistory());
      }
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.PACKAGE_PURCHASE_HISTORY, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      response.filter = data;
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getCustomPurchaseLink = createAsyncThunk(
  "getCustomPurchaseLink",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.GET_CUSTOM_PURCHASE_LINK, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure") {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      // showToast(response?.message, "success");
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const customPayWithBitanica = createAsyncThunk(
  "customPayWithBitanica",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.CUSTOM_PAYWITH_BITANICA, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure" && response?.status_code !== 503) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      // if (response?.status === "failure") {
      //   showToast(response?.message, "error");
      //   Thunk.dispatch(authSlice.actions.clearUserDetails());
      //   document.cookie = "";
      //   window.location.reload();
      //   return Thunk.rejectWithValue(response?.message);
      // }
      response.filter = data;
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      return Thunk.rejectWithValue(error);
    }
  },
);

export const createPaymentOrder = createAsyncThunk(
  "createPaymentOrder",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.CREATE_PAYMENT_ORDER, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      response.filter = data;
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getPaymentOrderDetails = createAsyncThunk(
  "getPaymentOrderDetails",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await get(
        URL.GET_PAYMENT_ORDER + `?order_id=${data.order_id}`,
        { signature, nonce },
      );
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      return Thunk.rejectWithValue(error);
    }
  },
);

export const payWithBitanica = createAsyncThunk(
  "payWithBitanica",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.PAY_WITH_BITANICA, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response?.status === "failure" && response?.status_code !== 503) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      // showToast(response?.message, "success");
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const cancelOrderBitanicaPay = createAsyncThunk(
  "cancelOrderBitanicaPay",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await post(URL.CANCEL_BITANICA_PAY_ORDER, data, {
        signature,
        nonce,
      });

      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);

        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();

        return Thunk.rejectWithValue(response?.message);
      }

      if (response?.status === "failure" && response?.status_code !== 503) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);

        return Thunk.rejectWithValue(response?.message);
      }

      showToast(response?.message, "success");
      if (response?.status_code !== 503) {
        showToast(response?.message, "success");
      }
      callBack && callBack(null, response);

      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");

      callBack && callBack(error);

      return Thunk.rejectWithValue(error);
    }
  },
);
